import React, { useEffect } from 'react';
import { Col, FormFeedback } from 'reactstrap';
import InputField from "../Utils/InputField";
import { LabelText } from "../Utils/Input";
import SelectField from "../Utils/SelectField";
import { handleDeviceTypeChange, handleStatusChange, getStatusValue } from "./constants/constantFunctions"
import StatusBadge from '../Customers/StatusBadge';
import { useSelector } from 'react-redux';

export function DeviceForm({
  values,
  isEdit,
  errors,
  touched,
  setFieldValue,
  initialValues,
  DeviceType,
  StatusType,
  handleChange
}) {
  const fetchDeviceData = useSelector((state) => state.fetchDevice.fetchDevice)
  useEffect(() => {
    values.deviceId = fetchDeviceData?.deviceId || "";
    values.deviceType = { "value": fetchDeviceData?.deviceType, "label": fetchDeviceData?.deviceType } || "";
    values.status = { "value": fetchDeviceData?.status, "label": fetchDeviceData?.status } || "";
  }, [fetchDeviceData]);
  return (
    <>
      <Col xxl={3} md={6}>
        <LabelText
          htmlFor="Device ID"
          classLabelName={"ms-0 rv-form-label"}
          className="text-danger"
          displayText="Device ID"
          important={"*"}
        />
        <LabelText
          htmlFor={"Device ID"}
          classLabelName={`d-block ms-0 rv-sub-label ${touched.deviceId && errors.deviceId
              ? "rv-label-danger"
              : "rv-label-muted"
            } `}
          displayText={
            touched.deviceId && errors.deviceId
              ? errors.deviceId
              : "Enter the device ID"
          }
        />
        <InputField
          value={values.deviceId}
          type={"text"}
          disabled={isEdit ? true : false}
          className={"form-control"}
          handleChange={handleChange}
          name={"deviceId"}
          placeholder={""}
          invalid={touched.deviceId && errors.deviceId ? true : false}
        />
      </Col>
      <Col xxl={3} md={6}>
        <LabelText
          htmlFor="Device Type"
          classLabelName={"ms-0 rv-form-label"}
          className="text-danger"
          displayText="Device Type"
          important={"*"}
        />
        <LabelText
          htmlFor={"Device Type"}
          classLabelName={`d-block ms-0 rv-sub-label ${touched.deviceType && errors.deviceType
              ? "rv-label-danger"
              : "rv-label-muted"
            } `}
          displayText={
            touched.deviceType && errors.deviceType
              ? errors.deviceType
              : "Select a device type"
          }
        />
        <SelectField
          isDisabled={isEdit ? true : false}
          className={
            (errors.deviceType && touched.deviceType) || false
              ? "error-input"
              : ""
          }
          id="deviceType"
          value={
            initialValues.deviceType
              ? DeviceType?.filter((deviceType) => {
                deviceType.label === initialValues.deviceType;
              })
              : values.deviceType
          }
          placeholder={" "}
          handleChange={handleDeviceTypeChange(setFieldValue)}
          options={[...DeviceType]}
          isRVStyle={true}
        />
      </Col>
      <Col xxl={3} md={6}>
        <LabelText htmlFor="Status" classLabelName={"ms-0 rv-form-label"} displayText="Status" />
        {!isEdit ? (
          <div className='mt-4 pt-1'>
            <StatusBadge value={"Unassigned"} />{" "}
          </div>
        ) : (
          <>
            <LabelText
              htmlFor={"Device Type"}
              classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"
                } `}
              displayText={
                "Select status"
              }
            />
            <SelectField
              value={
                getStatusValue(initialValues, StatusType, values)
              }
              isDisabled={values.status.label === "Assigned" ? true : false}
              handleChange={handleStatusChange(setFieldValue)}
              options={[...StatusType]}
            />
          </>
        )}
      </Col>
    </>
  );
}
